import { useState, useEffect, useCallback } from 'react';

export type CheckoutStep = 'cart' | 'shipping' | 'payment';

const VALID_STEPS: CheckoutStep[] = ['cart', 'shipping', 'payment'];

function parseHash(): CheckoutStep {
  const raw = window.location.hash.replace('#', '');
  if (VALID_STEPS.includes(raw as CheckoutStep)) return raw as CheckoutStep;
  return 'cart';
}

export function useHashStep() {
  const [step, setStepState] = useState<CheckoutStep>(parseHash);

  useEffect(() => {
    const onHashChange = () => setStepState(parseHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const setStep = useCallback((next: CheckoutStep) => {
    window.location.hash = next === 'cart' ? '' : next;
    setStepState(next);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const goBack = useCallback(() => {
    window.history.back();
  }, []);

  return { step, setStep, goBack };
}
